import styled from 'styled-components';
import { MapContainer } from "react-leaflet";


export const MapContentContainer = styled.div`
  flex-grow: 9;
  max-height: 100%;
  background: #313131;
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const StyledMapContainer = styled(MapContainer)`
  width: 100%;
  height: 100%;
`